import ReactDOM from "react-dom";
import App from "./App";
import "../styles/tailwind.css";
import "./styles/index.css";

document.addEventListener("DOMContentLoaded", function () {
	var element = document.getElementById("corksy-admin-app");
	if (typeof element !== "undefined" && element !== null) {
		ReactDOM.render(<App />, element);
	}
});
